import Grid from "@material-ui/core/Grid";
import React, {useEffect, useState} from "react";
import {DeleteUser, GetUsersList, VerifyUser} from "../../redux/Users/actions";
import {connect, useSelector} from "react-redux";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import moment from "moment";
import TablePagination from "@material-ui/core/TablePagination";
import {makeStyles} from "@material-ui/core/styles";
import {RootState} from "../../redux/store";
import {Chip, Table} from "@material-ui/core";
import {useCookies} from "react-cookie";
import {useHistory} from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {Routes} from "../../constants";
import {ENV} from "../../utils/constants";
import TableHeaderFilter from "../Common/TableHeaderFilter";

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%"
    },
    container: {
        maxHeight: "calc( 100vh - 220px)",
        minHeight: "calc( 100vh - 220px)"
    }
});

const options = [
    {title: "Edit", value: "edit"},
    {title: "Go to profile", value: "profile"},
    {title: "Delete", value: "delete"}
];

const ITEM_HEIGHT = 48;
const Users = ({GetUsersList, VerifyUser, DeleteUser}) => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const tableHeader = useSelector((store: RootState) => store?.users.tableHeader || []);
    const listingsData = useSelector((store: RootState) => store?.users.listingsData);
    const [page, setPage] = useState((listingsData?.current_page || 1) - 1);
    const rowsPerPage = 30;
    const history = useHistory();
    const [cookies] = useCookies(["token"]);
    const token = cookies["token"];
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>, user) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    useEffect(() => {
        const index = history?.location?.search.indexOf("=");
        const query = new URLSearchParams(history?.location?.search);
        const keyword = query.get('keyword');
        if (keyword) {
            getData({keyword});
        } else {
            const pageNo = parseInt(history?.location?.search.substr(index + 1));
            if (pageNo) {
                getData({page_number: pageNo});
                setPage(pageNo - 1);
            } else {
                getData({page_number: 1});
            }
        }
        // eslint-disable-next-line
    }, [history?.location?.search]);

    const getData = (data) => {
        setIsLoading(true);
        GetUsersList(token, data).then(() => {
            setIsLoading(false);
        });
    };

    const appendPageNumber = (pageNumber) => {
        history.push({
            pathname: Routes.users,
            search: `?page=${pageNumber}`
        });
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        appendPageNumber(newPage + 1);
    };

    const handleChange = (value, selectedUser) => {
        switch (value) {
            case "edit":
                history.push(`/edit${Routes.users}/${selectedUser?.user_id}`);
                break;
            case "verify":
                if (window?.confirm("Are you sure you want to verify this account?")) {
                    VerifyUser(token, selectedUser?.user_id).then(() => getData({page_number: page})).catch(() => {
                        alert("Something went wrong.");
                    });
                }
                break;
            case "suspend":
                console.log("suspended");
                break;
            case "profile":
                const url = ENV === "DEVELOPMENT" ? `https://www.timexyz.com/${selectedUser?.user_name}` :
                    `https://www.luxembourgexpats.lu/${selectedUser?.user_name}`;
                window.open(url, "_blank");
                break;
            case "delete":
                if (window?.confirm("Are you sure you want to delete this post?")) {
                    DeleteUser(token, selectedUser?.user_id).then(() => getData({page_number: page})).catch(() => {
                        alert("Something went wrong.");
                    });
                }
                break;
        }
    };

    const renderMenu = (user_id, user_name) => {
        return <>
            <IconButton aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={e => handleClick(e, {user_id, user_name})}>
                <MoreVertIcon/>
            </IconButton>
            <Menu id="long-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                      style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                          width: "20ch"
                      }
                  }}>
                {options.map((option, i) => (
                    <MenuItem key={option?.value}
                              onClick={() => {
                                  handleChange(option?.value, selectedUser);
                                  setAnchorEl(null);
                              }}>
                        {option?.title}
                    </MenuItem>
                ))}
            </Menu>
        </>;
    };

    return <Grid container spacing={0} className="h-100">
        <Grid item xs={12}>
            <Paper className={classes.root}>
                <TableHeaderFilter sectionBaseUrl={Routes.users}/>
                {isLoading ? <div className="mainLoader">
                    <div className="loader"/>
                </div> : <>
                    <TableContainer className={classes.container}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {tableHeader?.map((column) => (
                                        <TableCell key={column.id}>
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listingsData?.posts.length ? listingsData?.posts?.map(row => {
                                        const color = ["LIVE", "VERIFIED"].includes(row.status) ? "#319401" : "#ff0000";
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row?.user_id}
                                                      style={{padding: 0, cursor: "pointer"}}
                                                      onClick={(e) => {
                                                          history.push(`${Routes.users}/${row?.user_id}`);
                                                      }}>
                                                <TableCell size={"small"} onClick={e => e.stopPropagation()}>
                                                    {renderMenu(row?.user_id, row?.user_name)}
                                                </TableCell>
                                                <TableCell style={{color, minWidth: "100px"}} size={"small"}>
                                                    {moment(row?.createdAt).format("DD MMM, YYYY")}
                                                </TableCell>
                                                <TableCell style={{color}} size={"small"}>
                                                    {row?.type}
                                                </TableCell>
                                                <TableCell style={{color}} size={"small"}>
                                                    {row?.full_name}
                                                </TableCell>
                                                <TableCell style={{color}} size={"small"}>
                                                    {row?.email}
                                                </TableCell>
                                                <TableCell style={{color}} size={"small"}>
                                                    {row?.status}
                                                </TableCell>
                                                <TableCell style={{color}} size={"small"}
                                                           onClick={e => e.stopPropagation()}>
                                                    <Chip size="small"
                                                          label={row?.status === "VERIFIED" ? "Suspend" : "Verify"}
                                                          clickable
                                                          color={row?.status === "VERIFIED" ? "secondary" : "primary"}
                                                          onClick={() => {
                                                              handleChange(row?.status !== "VERIFIED" ? "verify" : "suspend",
                                                                  {user_id: row?.user_id, user_name: row?.user_name}
                                                              );
                                                          }}/>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }) :
                                    <tr>
                                        <td colSpan={tableHeader.length + 1} className="dataNotAvailable">
                                            Data not available
                                        </td>
                                    </tr>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination hidden={!listingsData?.posts.length}
                                     rowsPerPageOptions={[]}
                                     component="div"
                                     count={listingsData?.count}
                                     rowsPerPage={rowsPerPage}
                                     page={page}
                                     onChangePage={handleChangePage}/>
                </>}
            </Paper>
        </Grid>
    </Grid>;
};
export default connect(null, {GetUsersList, VerifyUser, DeleteUser})(Users);